var $class="se2--captcha",$name="captcha",$path="app/partials/captcha/config.js",$this={$class,$name,$path,};export const validationErrorMessageClassName = 'js-validation-error-message';
export const responseTokenClassName = 'g-recaptcha-response';
